import i18n from '@/plugins/i18n';

const addChannelVariableTableHeaders = () => [
  {
    key: 'variableName',
    name: i18n.global.t('notification.variable'),
    width: '39%',
  },
  {
    key: 'variableInfo',
    name: i18n.global.t('notification.description'),
    width: '61%',
  },
];

const addChannelVariablesList = [
  // Common keys
  { label: 'service_name', type: 'variable' },
  { label: 'metric_name', type: 'variable' },
  {
    label: 'aggregator_operator',
    type: 'variable',
  },
  {
    label: 'threshold_value',
    type: 'variable',
  },

  // Alert keys
  { label: 'event_type', type: 'variable' },
  { label: 'severity', type: 'variable' },
  { label: 'timestamp', type: 'variable' },
  { label: 'tool_name', type: 'variable' },
  { label: 'current_value', type: 'variable' },
  { label: 'period', type: 'variable' },
  { label: 'url', type: 'variable' },

  //  Tagging keys
  { label: 'priority', type: 'variable' },
  { label: 'alert_name', type: 'variable' },
  {
    label: 'end_timestamp',
    type: 'variable',
  },
  { label: 'agg_time', type: 'variable' },
  {
    label: 'total_unique_rules_violated',
    type: 'variable',
  },
  {
    label: 'notification_text',
    type: 'variable',
  },
  {
    label: 'total_occurrences',
    type: 'variable',
  },
  { label: 'ci', type: 'variable' },
];

const addChannelVariableTableItems = () => [
  {
    variableName: '{{alert_name}}',
    variableInfo: i18n.global.t('notification.dataFieldAlertNameInfo'),
  },
  {
    variableName: '{{capability}}',
    variableInfo: i18n.global.t('notification.dataFieldCapabilityInfo'),
  },
  {
    variableName: '{{service_name}}',
    variableInfo: i18n.global.t('notification.dataFieldServiceNameInfo'),
  },
  {
    variableName: '{{event_type}}',
    variableInfo: i18n.global.t('notification.dataFieldEventTypeInfo'),
  },
  {
    variableName: '{{severity}}',
    variableInfo: i18n.global.t('notification.dataFieldSeverityInfo'),
  },
  {
    variableName: '{{timestamp}}',
    variableInfo: i18n.global.t('notification.dataFieldTimestampInfo'),
  },
  {
    variableName: '{{tool_name}}',
    variableInfo: i18n.global.t('notification.dataFieldToolNameInfo'),
  },
  {
    variableName: '{{metric_name}}',
    variableInfo: i18n.global.t('notification.dataFieldMetricNameInfo'),
  },
  {
    variableName: '{{aggregator_operator}}',
    variableInfo: i18n.global.t('notification.dataFieldAggregatorOperatorInfo'),
  },
  {
    variableName: '{{current_value}}',
    variableInfo: i18n.global.t('notification.dataFieldCurrentValueInfo'),
  },
  {
    variableName: '{{threshold_value}}',
    variableInfo: i18n.global.t('notification.dataFieldThresholdValueInfo'),
  },
  {
    variableName: '{{period}}',
    variableInfo: i18n.global.t('notification.dataFieldPeriodInfo'),
  },
  {
    variableName: '{{url}}',
    variableInfo: i18n.global.t('notification.dataFieldUrlInfo'),
  },
];

const addTaggingChannelVariableTableItems = () => [
  {
    variableName: '{{priority}}',
    variableInfo: i18n.global.t('notification.dataFieldPriorityInfo'),
  },
  {
    variableName: '{{alert_name}}',
    variableInfo: i18n.global.t('notification.dataFieldAlertNameInfo'),
  },
  {
    variableName: '{{end_timestamp}}',
    variableInfo: i18n.global.t('notification.dataFieldEndTimestampInfo'),
  },
  {
    variableName: '{{agg_time}}',
    variableInfo: i18n.global.t('notification.dataFieldAggTimeInfo'),
  },
  {
    variableName: '{{total_unique_rules_violated}}',
    variableInfo: i18n.global.t(
      'notification.dataFieldTotalUniqueRulesViolatedInfo',
    ),
  },
  {
    variableName: '{{notification_text}}',
    variableInfo: i18n.global.t('notification.dataFieldNotificationTextInfo'),
  },
  {
    variableName: '{{service_name}}',
    variableInfo: i18n.global.t('notification.dataFieldServiceNameInfo'),
  },
  {
    variableName: '{{metric_name}}',
    variableInfo: i18n.global.t('notification.dataFieldMetricNameInfo'),
  },
  {
    variableName: '{{aggregator_operator}}',
    variableInfo: i18n.global.t('notification.dataFieldAggregatorOperatorInfo'),
  },
  {
    variableName: '{{threshold_value}}',
    variableInfo: i18n.global.t('notification.dataFieldThresholdValueInfo'),
  },
  {
    variableName: '{{total_occurrences}}',
    variableInfo: i18n.global.t('notification.dataFieldTotalOccurancesInfo'),
  },
  {
    variableName: '{{ci}}',
    variableInfo: i18n.global.t('notification.dataFieldCIInfo'),
  },
  {
    variableName: '{{current_value}}',
    variableInfo: i18n.global.t('notification.dataFieldCurrentValueInfo'),
  },
];

const defaultWebHookTemplate =
  '{"ALERT_NAME":"{{alert_name}}","CAPABILITY":"{{capability}}","SEVERITY":"{{severity}}","ENTITY_NAME":"{{service_name}}","DESC":"{{event_type}}","COMP":"{{metric_name}}","NOTES":"{{tool_name}} has detected a problem with {{service_name}} application where {{metric_name}} was {{aggregator_operator}} {{threshold_value}} and the current value is around {{current_value}} for the last {{period}} min(s).","TIME":"{{timestamp}}","TOOL_NAME":"{{tool_name}}","URL":"{{url}}"}';

const defaultTaggingWebhookTemplate =
  '{"SUMMARY":"{{priority}} - Alerts were tagged under group rule {{alert_name}}. Review details and take action.","ALERT_NAME":"{{alert_name}}","PRIORITY":"{{priority}}","END_TIME":"{{end_timestamp}}","AGG_TIME":"{{agg_time}}","TOTAL_UNIQUE_RULES_VIOLATED":"{{total_unique_rules_violated}}","NOTIFICATION_TEXT":"{{notification_text}}","TRIGGERED_RULES":["{{service_name}} application where {{metric_name}} was {{aggregator_operator}} {{threshold_value}} and the current value is around {{current_value}} for the last {{period}} min(s) with total occurrences {{total_occurrences}}."],"CI":"{{ci}}"}';

const deleteChannelAlertInfoHeader = [{ key: 'name', width: '100%' }];

const notificationHeaders = () => [
  {
    key: 'channelName',
    name: i18n.global.t('notificationChannelName'),
    width: '40%',
    sortable: true,
    routable: false,
  },
  {
    key: 'type',
    name: i18n.global.t('channelType'),
    width: '15%',
    sortable: true,
    routable: false,
  },
  {
    key: 'lastUpdatedAt',
    name: i18n.global.t('lastModified'),
    width: '15%',
    routable: false,
    sortable: true,
    defaultSortBy: true,
    defaultOrder: 'DES',
  },
  {
    key: 'createdAt',
    name: i18n.global.t('createdOn'),
    width: '15%',
    routable: false,
    sortable: true,
  },
  {
    type: 'actions',
    name: i18n.global.t('action'),
    key: 'Actions',
    width: '15%',
  },
];
export {
  addChannelVariableTableHeaders,
  addChannelVariableTableItems,
  addTaggingChannelVariableTableItems,
  addChannelVariablesList,
  defaultWebHookTemplate,
  defaultTaggingWebhookTemplate,
  deleteChannelAlertInfoHeader,
  notificationHeaders,
};
